import React from "react";

const StepProgress = ({ currentStep }) => {
  const steps = ["Agreement", "Membership", "Service Fee", "Bank Details"];

  return (
    <div className="flex items-center justify-center mb-6 mt-4">
      {steps.map((step, index) => {
        const isCompleted = index < currentStep;
        const isCurrent = index === currentStep;

        return (
          <div key={index} className="flex items-center">
            {/* Circle */}
            <div
              className={`rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold font-poppins border transition-colors duration-300 ${
                isCompleted
                  ? "bg-[green] text-[#fff] border-green-600"
                  : isCurrent
                  ? "bg-white text-blue-600 border-white"
                  : "bg-gray-300 text-gray-400 border-gray-300"
              }`}
            >
              {index + 1}
            </div>

            {/* Step label */}
            <div
              className={`text-sm mx-2 font-poppins font-medium ${
                isCompleted || isCurrent ? "text-white" : "text-gray-400"
              }`}
            >
              {step}
            </div>

            {/* Connector */}
            {index < steps.length - 1 && (
              <div
                className={`w-10 h-1 transition-colors duration-300 font-poppins ${
                  isCompleted || isCurrent ? "bg-white" : "bg-gray-400"
                }`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default StepProgress;
